<style src="./EmployeeMap.scss" lang="scss"></style>
<template>
  <div>
    <form @submit.prevent class="formcontainer">
      <div class="inputcontainer">
        <div class="inputcontent">
          <label>Digite o inicio do periodo</label>
          <input
            type="datetime-local"
            :min="initialDateLimit"
            :max="initialDateLimit"
            class="form-control"
            v-model="form.dateTimeInitial"
          />
        </div>
        <div class="inputcontent">
          <label>Digite o fim do periodo</label>
          <input
            type="datetime-local"
            :min="initialDateLimit"
            :max="initialDateLimit"
            class="form-control"
            v-model="form.dateTimeFinal"
          />
        </div>
        <div class="inputcontent">
          <label>Selecione o monitor</label>
          <select class="form-select" v-model="form.selectedEmployee">
            <option
              v-for="(employee, index) in employees"
              :key="index"
              :value="employee.userToken"
              >{{ employee.fullName }}</option
            >
          </select>
        </div>
      </div>
      <div class="input-group-btn">
        <button
          type="button"
          class="btn btn-lg btn-primary"
          @click="loadEmployeeLocation"
        >
          <i class="fa fa-search"></i>
          Buscar
        </button>
      </div>
    </form>
    <l-map
      ref="mapRef"
      class="mapcontainer"
      :zoom="16"
      :center="center"
      @ready="onMapReady"
    >
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer } from '@vue-leaflet/vue-leaflet';
import L from 'leaflet';
import 'leaflet.heat';
import { format } from 'date-fns';
import { toast } from '@/plugins/toast';

export default {
  name: 'EmployeeMap',
  components: { LMap, LTileLayer },
  data: () => ({
    center: [-22.4732992, -43.8566519],
    employeesLocations: [],
    employees: [],
    mapObject: null,
    heatLayer: null,
    form: {
      dateTimeInitial: '',
      dateTimeFinal: '',
      selectedEmployee: '',
    },
    initialDateLimit: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
  }),
  watch: {
    employeesLocations(locations) {
      this.updateHeatmap(locations);
    },
  },
  mounted() {
    this.loadEmployees();
  },
  methods: {
    onMapReady(mapObject) {
      this.mapObject = mapObject;
    },
    updateHeatmap(locations) {
      if (!this.mapObject) return;
      if (this.heatLayer) {
        this.heatLayer.remove();
        this.heatLayer = null;
      }
      const points = locations.map((e) => [e.coordinates[0], e.coordinates[1], 10]);
      this.heatLayer = L.heatLayer(points, {
        radius: 50,
        opacity: 0.8,
      }).addTo(this.mapObject);
    },
    async loadEmployeeLocation() {
      try {
        const employeeLocations = await this.$store.dispatch(
          'EMPLOYEE/ListEmployeeLocation',
          {
            dateTimeInitial: this.form.dateTimeInitial,
            dateTimeFinal: this.form.dateTimeFinal,
            employeeToken: this.form.selectedEmployee,
          }
        );
        employeeLocations.location
          ? (this.employeesLocations = employeeLocations.location)
          : (this.employeesLocations = employeeLocations);
      } catch (error) {
        toast.error('Não foi possível listar a localização dos monitores');
      }
    },
    async loadEmployees() {
      try {
        const employeesList = await this.$store.dispatch(
          'EMPLOYEE/GetEmployeeList',
          { accountEnabled: true }
        );
        this.employees = employeesList;
        this.form.selectedEmployee = employeesList[0].userToken;
      } catch (error) {
        toast.error('Não foi possível listar os monitores');
      }
    },
  },
};
</script>
